<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!-- title -->
        <div class="grid-title no-border borderTop">
          <h4 style="padding-left: 6px"> {{ i18nValues["palletMovements"] }} </h4>
        </div>
      
        <!-- form -->
        <div class="grid-body no-border borderBottom">
          <el-form>
            <div class="filters-wrapper">
              <div class="filters-row">
                <!-- Pallet Code -->
                <el-form-item :label="i18nValues['palletCode']" prop="id">
                  <el-input v-model="filter.id" :placeholder="i18nValues['palletCode']"></el-input>
                </el-form-item>

                <!-- Creation Date From -->
                <el-form-item :label="i18nValues['from']" prop="dateSince">
                  <div class="input-group">
                    <el-date-picker 
                      v-model="filter.dateSince"
                      type="date" 
                      format="dd/MM/yyyy"
                      :clearable="true"
                      :placeholder="i18nValues['from']"
                    >
                    </el-date-picker>
                    <span class="input-group-addon primary el-input__suffix icon">
                      <span class="arrow"></span>
                      <i class="fa fa-calendar-alt"></i>
                    </span>
                  </div>
                </el-form-item>

                <!-- Creation Date Until -->
                <el-form-item :label="i18nValues['to']" prop="dateUntil">
                  <div class="input-group">
                    <el-date-picker 
                      v-model="filter.dateUntil"
                      type="date" 
                      format="dd/MM/yyyy"
                      :clearable="true"
                      :placeholder="i18nValues['to']"
                    >
                    </el-date-picker>
                    <span class="input-group-addon primary el-input__suffix icon">
                      <span class="arrow"></span>
                      <i class="fa fa-calendar-alt"></i>
                    </span>
                  </div>
                </el-form-item>
                
                <!-- Search Button -->
                <el-button
                  @click="retrievePalletsTrxBySearch()"
                  icon="fas fa-search"
                  id="searchButton"
                  size="small"
                  class="btn-primary"
                >
                  {{ i18nValues["search"] }}
                </el-button>
              </div>
            </div>
  
            <!-- table -->
            <el-form-item prop="stockTransfers">
              <div class="table-container" v-loading="loading" style="margin:5 auto;padding:15px; width: 100%;">
                <!-- <h5 style="padding-left: 6px;"> {{ i18nValues["stockTransfers"] }}  </h5> -->
                  <el-table
                    :data="PalletsTrxSubList"
                    id="StockTransferTable"
                    class="table table-hover"
                    align="left"
                    with="20%"
                    :empty-text="hasAttemptedLoad ? i18nValues['noDataAvailable'] : ''"
                    @sort-change="handleSortChange"
                    :default-sort="tableDefaultSort"
                    stripe
                  >

                    <!-- Date -->
                    <el-table-column
                      prop="date" 
                      :formatter="formatPalletTrxDate"
                      :label= "i18nValues['date']"
                      width="75"
                      align="left"
                      sortable
                    ></el-table-column>

                    <!-- User -->
                    <el-table-column
                      prop="user" 
                      :label= "i18nValues['user']"
                      width="75"
                      align="center"
                      sortable
                    ></el-table-column>

                    <!-- Code -->
                    <el-table-column
                      prop="pallet.id" 
                      :label= "i18nValues['palletCode']"
                      width="80"
                      align="right"
                      sortable
                    ></el-table-column>

                    <!-- ID NUMBER -->
                    <el-table-column
                      prop="pallet.idNumber"
                      :label="i18nValues['idNumber']"
                      width="94"
                      align="right"
                      sortable
                    ></el-table-column>

                    <!-- Label -->
                    <el-table-column
                      prop="pallet.label.id" 
                      :label= "i18nValues['numberOfLabel']"
                      width="75"
                      align="right"
                      sortable
                    ></el-table-column>

                    <!-- FieldSiteOrigin -->
                    <el-table-column
                      prop="fieldSiteOrigin.name" 
                      :label= "i18nValues['originFieldSite']"
                      width="120"
                      align="center"
                      sortable
                    ></el-table-column>

                    <!-- FieldSiteODesitination -->
                    <el-table-column
                      prop="fieldSiteDestination.name" 
                      :label= "i18nValues['destinationFieldSite']"
                      width="120"
                      align="center"
                      sortable
                    ></el-table-column>

                    
                    <!-- <el-table-column
                      width="75"
                      align="center"
                    ></el-table-column>
   -->
                    <!-- EDIT/DELETE -->
                    <!-- <el-table-column width="90" align="right">
                      <template slot-scope="scope">
                        <el-button 
                          class="text-info"
                          icon="fas fa-edit"
                          size="small"
                          :title="i18nValues['edit']"
                          @click="edit(scope.row.id)"
                        ></el-button>
  
                        <el-button 
                          class="text-danger"
                          icon="fas fa-times"
                          size="small"
                          :title="i18nValues['remove']"
                          @click="deleteEvent(scope.row.id)"
                        ></el-button>
                      </template>
                     </el-table-column>                   -->
                </el-table>
                <div v-if="90 > 10" style="height: 15px"></div>
                  <div class="pagination-bar">
                    <PaginationFunctional
                      ref="pagination"
                      sublistName="PalletsTrxSubList"
                      :fullList="PalletsTrxList"
                      :tableSize="20"
                      :tableIndexInitial="currentPageIndex"
                      @paginationChange="paginationChange"
                      @currentIndexPagination="setCurrentPage"
                      class="text-center"
                    />
                    <div v-if="PalletsTrxList.length > 0" class="results-info">
                      <p>
                        {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                      </p>
                    </div>
                  </div> 
              </div>
            </el-form-item>  
  
          </el-form>

        </div>
  
      </div>
    </div>
  </template>
  
<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue"

const normalizeDateInput = (value) => {
  if (value === undefined || value === null || value === "") {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === "number") {
    const fromNumber = new Date(value);
    return isNaN(fromNumber.getTime()) ? null : fromNumber;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    const match = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]) - 1;
      const day = Number(match[3]);
      const localDate = new Date(year, month, day);
      return isNaN(localDate.getTime()) ? null : localDate;
    }
    const parsed = new Date(trimmed);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
};
  export default {
    name: "StockTransferAdmin",
    created() {
      this.restoreFromQuery();
    },
  
    components: {
      PaginationFunctional 
    },
  
    computed: {
      loading: get("event/loading"),
      globalFieldSite: get("globalFieldSite"),

      // Pagination helpers for results label
      currentPage() {
        if (typeof this.currentPageIndex === "number") {
          return this.currentPageIndex;
        }
        if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
          return this.$refs.pagination.tableIndex;
        }
        return 1;
      },
      pageSize() {
        return 20; // Keep in sync with PaginationFunctional :tableSize
      },
      totalRecords() {
      if (Array.isArray(this.PalletsTrxList)) {
        return this.PalletsTrxList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
      },
      startIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const start = (this.currentPage - 1) * this.pageSize + 1;
        return Math.min(start, this.totalRecords);
      },
      endIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const end = this.currentPage * this.pageSize;
        return Math.min(end, this.totalRecords);
      },

      tableDefaultSort() {
        if (this.sortProp && this.sortOrder) {
          return { prop: this.sortProp, order: this.sortOrder };
        }
        return {};
      },
    },
  
    props:{
      componentsMap: {},
    },

    watch: {
      globalFieldSite: {
        immediate: true,
        handler(newVal, oldVal) {
          if (!newVal || !newVal.id) return;
          if (oldVal && oldVal.id === newVal.id) return;
          this.requestGeneration++;
          // Reset filters only when context actually changes (not on initial load)
          if (oldVal && oldVal.id) {
            this.filter.id = null;
            this.filter.dateSince = null;
            this.filter.dateUntil = null;
          }
          this.fetchPalletsTrx(true);
          this.retrievePalletTrxCount();
        },
      },
    },
  
    data() {
      const q = (this.$route && this.$route.query) || {};
      
      return {
        filter: {
          id: q.id || null,
          dateSince: normalizeDateInput(q.dateSince),
          dateUntil: normalizeDateInput(q.dateUntil),
        },

        PalletsTrxList: [],
        PalletsTrxSubList: [],
        originalPalletsTrxList: [],
  
        StockTransfersList: [
            {
                id: 1,
                product: {
                    id: 1,
                    brand: "Marca 1"
                },
                fieldSite: {
                    id: 1,
                    name: "Planta 1"
                },
                quantity: 1520
            },
            {
                id: 2,
                product: {
                    id: 2,
                    brand: "Marca 2"
                },
                fieldSite: {
                    id: 2,
                    name: "Planta 2"
                },
                quantity: 2380
            }
        ],
        StockTransfersSubList: [],
        cantidad: 100,
        currentPageIndex: q.page ? Number(q.page) : 1,
        sortProp: q.sortProp || null,
        sortOrder: q.sortOrder || null,
        requestGeneration: 0,
        hasAttemptedLoad: false,
  
      };
    },
  
    methods: {
      fetchPalletsTrx(preservePage) {
        if (!this.globalFieldSite || !this.globalFieldSite.id) {
          this.PalletsTrxList = [];
          this.PalletsTrxSubList = [];
          this.originalPalletsTrxList = [];
          return;
        }
        this.hasAttemptedLoad = true;
        const gen = this.requestGeneration;
        const hasFilters = !!(this.filter.id || this.filter.dateSince || this.filter.dateUntil);
        const payload = hasFilters
          ? {
              id: this.filter.id || null,
              dateSince: this.filter.dateSince instanceof Date ? this.filter.dateSince.getTime() : this.filter.dateSince,
              dateUntil: this.filter.dateUntil instanceof Date ? this.filter.dateUntil.getTime() : this.filter.dateUntil,
            }
          : { id: this.globalFieldSite.id };
        const action = hasFilters ? "pallet/retrievePalletsTrxBySearch" : "pallet/retrievePalletsTrx";
        this.$store.dispatch(action, payload).then((res) => {
          if (gen !== this.requestGeneration) return;
          if (!res || res.length === 0) {
            this.PalletsTrxList = [];
            this.PalletsTrxSubList = [];
            this.originalPalletsTrxList = [];
            this.syncRouteFromState();
            return;
          }
          this.originalPalletsTrxList = res;
          // Apply current sort, default to date descending
          if (this.sortProp && this.sortOrder) {
            const dir = this.sortOrder === "descending" ? -1 : 1;
            this.PalletsTrxList = [...res].sort((a, b) => {
              const aVal = this.getNestedValue(a, this.sortProp);
              const bVal = this.getNestedValue(b, this.sortProp);
              if (aVal == null && bVal == null) return 0;
              if (aVal == null) return 1;
              if (bVal == null) return -1;
              return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
            });
          } else {
            this.PalletsTrxList = res.sort((a, b) => new Date(b.date) - new Date(a.date));
          }
          if (!preservePage) this.currentPageIndex = 1;
          this.syncRouteFromState();
          this.$nextTick(() => {
            const page = preservePage ? (this.currentPageIndex || 1) : 1;
            if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
              this.$refs.pagination.currentChange(page);
            }
          });
        }).catch((error) => {
          console.error("Error retrieving pallets:", error); //eslint-disable-line
        });
      },

      retrievePalletsTrx() {
        this.fetchPalletsTrx(false);
      },

      retrievePalletsTrxBySearch() {
        this.fetchPalletsTrx(false);
      },

      getNestedValue(obj, path) {
        if (!obj || !path) return null;
        return path.split(".").reduce((acc, key) => (acc != null ? acc[key] : null), obj);
      },
  
      handleSortChange(event) {
        const nextProp = event && event.prop ? event.prop : null;
        const nextOrder = event && event.order ? event.order : null;
        if (this.sortProp === nextProp && this.sortOrder === nextOrder) return;
        this.sortProp = nextProp;
        this.sortOrder = nextOrder;

        const currentPage = this.$refs.pagination && this.$refs.pagination.tableIndex
          ? this.$refs.pagination.tableIndex
          : this.currentPageIndex || 1;
        this.currentPageIndex = currentPage;

        if (this.sortProp && this.sortOrder && this.originalPalletsTrxList.length) {
          const dir = this.sortOrder === "descending" ? -1 : 1;
          this.PalletsTrxList = [...this.originalPalletsTrxList].sort((a, b) => {
            const aVal = this.getNestedValue(a, this.sortProp);
            const bVal = this.getNestedValue(b, this.sortProp);
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return 1;
            if (bVal == null) return -1;
            return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: "base" }) * dir;
          });
        } else {
          this.PalletsTrxList = [...this.originalPalletsTrxList];
        }

        this.syncRouteFromState();
        this.$nextTick(() => {
          if (this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
            this.$refs.pagination.currentChange(currentPage);
          }
        });
      },

      formatPalletTrxDate(row) {
        return this.formatDateHour(row.date);
      },

      paginationChange(evt) {
        if (evt && evt.list) {
          this.PalletsTrxSubList = evt.list;
        }
        this.syncRouteFromState();
      },

      setCurrentPage(idx) {
        if (typeof idx === "number") {
          this.currentPageIndex = idx;
          this.syncRouteFromState();
        }
      },

      retrievePalletTrxCount() {
        if (!this.globalFieldSite || !this.globalFieldSite.id) return;
        const gen = this.requestGeneration;
        const filter = {
          fieldSiteId: this.globalFieldSite.id
        };
        this.$store
          .dispatch("pallet/countPalletTrx", filter)
          .then((res) => {
            if (gen !== this.requestGeneration) return;
            this.cantidad = res;
          });
      },

      // --- Query sync helpers ---
      restoreFromQuery() {
        const q = this.$route.query || {};
        this.filter.id = q.id || null;
        this.filter.dateSince = normalizeDateInput(q.dateSince);
        this.filter.dateUntil = normalizeDateInput(q.dateUntil);
        if (q.page) this.currentPageIndex = Number(q.page);
        if (q.sortProp) this.sortProp = q.sortProp;
        if (q.sortOrder) this.sortOrder = q.sortOrder;
      },

      syncRouteFromState() {
        const q = {};
        if (this.filter.id) q.id = this.filter.id;
        if (this.filter.dateSince) q.dateSince = this.serializeDate(this.filter.dateSince);
        if (this.filter.dateUntil) q.dateUntil = this.serializeDate(this.filter.dateUntil);
        const page = this.$refs.pagination && this.$refs.pagination.tableIndex
          ? this.$refs.pagination.tableIndex
          : this.currentPageIndex || 1;
        if (page && page > 1) q.page = String(page);
        if (this.sortProp) q.sortProp = this.sortProp;
        if (this.sortOrder) q.sortOrder = this.sortOrder;
        if (this.globalFieldSite && this.globalFieldSite.id) q.fieldSiteId = String(this.globalFieldSite.id);
        // Only navigate if query actually changed
        const current = this.$route.query || {};
        const keys = new Set([...Object.keys(q), ...Object.keys(current)]);
        let same = true;
        for (const k of keys) {
          if (String(q[k] || "") !== String(current[k] || "")) { same = false; break; }
        }
        if (!same) {
          this.$router.replace({ query: q }).catch(() => {});
        }
      },

      serializeDate(value) {
        const dt = this.coerceDate(value);
        if (!dt) {
          return undefined;
        }
        const y = dt.getFullYear();
        const m = `${dt.getMonth() + 1}`.padStart(2, "0");
        const day = `${dt.getDate()}`.padStart(2, "0");
        return `${y}-${m}-${day}`;
      },

      parseDate(value) {
        return this.coerceDate(value);
      },

      coerceDate(value) {
        return normalizeDateInput(value);
      },
      
    },
  
  };
  
  </script>

  <style scoped>
/* Filters wrapper - single horizontal line */
.filters-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.filters-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
}

.filters-row /deep/ .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/* Make inputs narrower */
.filters-row /deep/ .el-input,
.filters-row /deep/ .el-select {
  width: 140px;
}

/* Date picker slightly wider */
.filters-row /deep/ .el-date-editor {
  width: 150px;
}


/* Buttons in the same row, aligned to bottom */
.filters-row /deep/ .el-button {
  flex-shrink: 0;
}

/* Table container with minimum height to prevent loading overlay jumping */
.table-container {
  min-height: 400px;
  position: relative;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
  </style>